// extracted by mini-css-extract-plugin
module.exports = {"freight-templates":"FreightTemplates_freight-templates__IQ1WD","container":"FreightTemplates_container__47gnV"};